// Overlapcontrole (SPEC_wijzigingen 5.4) aan de clientkant: na elke wijziging van de werkposten
// opnieuw nagaan welke posten al in een andere post zitten. pasOverlapToe is idempotent, dus dit
// convergeert na één ronde.
import { useEffect } from 'react';
import { pasOverlapToe, type MatchedLine, type OverlapBeslissing, type PricelistItem } from '@recotex/shared';

function overlapHandtekening(lines: MatchedLine[]): string {
  return lines.map((l) => `${l.id}:${l.overlap ? `${l.overlap.itemCode}>${l.overlap.inbegrepenInCode}=${l.overlap.status}` : '-'}`).join('|');
}

export function useOverlapSync(
  lines: MatchedLine[],
  setLines: (lines: MatchedLine[]) => void,
  items: PricelistItem[],
  geleerd: Array<{ sleutel: string; beslissing: OverlapBeslissing }> | undefined,
  enabled: boolean,
): void {
  useEffect(() => {
    if (!enabled || !items.length) return;
    const r = pasOverlapToe(lines, items, new Map((geleerd ?? []).map((g) => [g.sleutel, g.beslissing] as const)));
    if (overlapHandtekening(r.matchedLines) !== overlapHandtekening(lines)) setLines(r.matchedLines);
  }, [lines, items, geleerd, enabled, setLines]);
}
